import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import { RecentBusinessLocationResponse } from '../../../types/events';

function formatVenueLine(v: RecentBusinessLocationResponse): string {
  const parts = [
    v.address_line_1,
    v.address_line_2,
    [v.city, v.state, v.postal_code].filter(Boolean).join(', '),
  ].filter((p) => (p || '').trim());
  return parts.join(' · ');
}

export type RecentBusinessLocationDialogProps = {
  open: boolean;
  venues: RecentBusinessLocationResponse[];
  onSelect: (venue: RecentBusinessLocationResponse) => void;
  onEnterNew: () => void;
};

/** Prompt to reuse a chapter business venue or enter a new address. */
export const RecentBusinessLocationDialog: React.FC<
  RecentBusinessLocationDialogProps
> = ({ open, venues, onSelect, onEnterNew }) => {
  return (
    <Dialog open={open} onClose={onEnterNew} maxWidth="sm" fullWidth>
      <DialogTitle>Use a previous location?</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          This chapter has used these business locations in the past 13 months.
          Select one or enter a new address.
        </Typography>
        <List dense>
          {venues.map((v) => (
            <ListItemButton
              key={v.address_id}
              onClick={() => onSelect(v)}
              alignItems="flex-start"
            >
              <ListItemText
                primary={v.location_name?.trim() || 'Unnamed location'}
                secondary={formatVenueLine(v)}
              />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onEnterNew}>Enter new address</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecentBusinessLocationDialog;
